






















import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DeferModes, DeferModesValues } from "@/data/enums/provisioning";

@Component
export default class ProvisionDeferModeField extends Mixins(HasValidation) {
  // Props

  @Prop({ required: true })
  public value!: DeferModes | null;

  @Prop({ default: null })
  public categoryValue!: DeferModes;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public deferMode = "";

  // Life-cycle methods

  public created() {
    this.deferMode = _.isNull(this.value) ? "inherit" : this.value;
  }

  // Methods

  public changeDeferMode(value) {
    this.$emit("input", value === "inherit" ? null : value);
  }

  // Computed

  public get deferModes() {
    return _.concat(
      _.isNull(this.categoryValue)
        ? []
        : [
            {
              value: "inherit",
              label: this.$t("_.inherit_from_category", {
                value: this.categoryValueLabel
              }),
              desc: ""
            }
          ],
      DeferModesValues()
    );
  }

  public get categoryValueLabel() {
    return _.get(
      _.find(DeferModesValues(), ["value", this.categoryValue]),
      "label"
    );
  }
}
